import VideoCard from '@/components/feature/VideoCard';
import { featuredVideos } from '@/mocks/home';

export default function FeaturedVideos() {
  return (
    <section className="py-14 md:py-20">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            热门视频推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            精选优质时尚视频内容，从穿搭到美妆，帮你解锁更多时尚可能
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredVideos.map((video) => (
            <VideoCard
              key={video.id}
              id={video.id}
              title={video.title}
              cover={video.cover}
              duration={video.duration}
              views={video.views}
              author={video.author}
              authorAvatar={video.authorAvatar}
              slug={video.slug}
              category={video.category}
            />
          ))}
        </div>
      </div>
    </section>
  );
}